import {
  Component,
  Input,
} from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import * as _ from 'lodash';
import * as utils from 'utils/utils';
import * as dateUtils from 'utils/date';

@Component({
  template: ''
})
export class TableComponent {
  headers: any[] = [];
  validators: any;
  @Input() data: any[] = [];
  @Input() segmentData: any[] = [];

  public getFieldValue(item: any, field: any): string {
    return utils.getFieldValue(item, field);
  }

  public getFieldTitle(name: string): string {
    return utils.getFieldTitle(name, this.segmentData);
  }

  public getFieldByName(name: string): any {
    return utils.getFieldByName(name, this.segmentData);
  }

  public getFieldByMap(fieldMap: string): any {
    return utils.getFieldByMap(fieldMap, this.segmentData);
  }

  public getLookup(name: string): any {
    return utils.getLookup(name, this.segmentData);
  }

  public getLookupTitle(option: string, lookup: Array<any>): string {
    return utils.getLookupTitle(option, lookup);
  }

  public isHeader(name: string): boolean {
    return _.indexOf(this.headers, name) >= 0;
  }

  public  getOptions(name: string, data: Array<any>): any[] {
    const options = utils.getOptions(name, data);
    return options;
  }

  public getFieldCellSize(fieldName: string, fieldsInfo: any): string {
    const fieldCellSize = utils.getFieldCellSize(fieldName, fieldsInfo);
    return fieldCellSize;
  }

  public getItemValidators(itemValidation: any): any {
    return utils.getItemValidators(itemValidation, this);
  }

  public getMaxLength(item: any): number|string {
    return utils.getMaxLength(item);
  }

  public hasError(field: any, form: UntypedFormGroup | AbstractControl): boolean {
    return utils.hasError(field, form);
  }

  public fieldErrorDetail(item: any, formGroup: UntypedFormGroup) {
    if (!item || !item.title || !formGroup) { return ''; }
    const control = formGroup.controls[item.field_map];
    return this.controlErrorDetail(item, control);
  }

  public controlErrorDetail(item: any, control: AbstractControl) {
    if (!item || !item.title || !control) { return ''; }
    if (control.valid) { return ''; }
    if (control.errors) {
      const error = _.values(control.errors);
      if (_.isString(error[0])) { return error[0]; }
    }
    /*
    * TODO: We need to add ability to handle multiple validations.
    * Only for one validation now.
    */
    const keys  = _.keys(item.validation);
    if (!keys.length) { return ''; }
    return _.get(item, `validation.${keys[0]}.message`, '');
  }

  public fieldValidation(item: any, formGroup: UntypedFormGroup): any {
    if (!item.validation || !formGroup) { return []; }
    const control = formGroup.controls[item.field_map];
    return _.map(item.validation, (value: any, key: string) => {
      /*
      * TODO: We need to readdress how handle validating different types.
      * TODO: We need to add ability to handle multiple validations.
      * Only for one validation now.
      */
      return {
        name: key,
        // valid: !_.some(_.keys(value), (key: string) => _.has(control.errors, key.toLowerCase())),
        valid: control.valid,
      };
    });
  }

  public controlValidation(item: any, formControl: AbstractControl): any {
    return utils.controlValidation(item, formControl);
  }

  public initValidators(validation: any): any[] {
    return utils.initValidators(validation, this);
  }

  public switchField(fieldName: string, fieldsInfo: any): string {
    return utils.switchField(fieldName, fieldsInfo);
  }

  public setValidators(): void {
    if (this.validators) { return; }
    this.validators = _.reduce(this.segmentData, (result: any, item: any) => {
      if (!item.validation) { return result; }
      (<any>result)[item.item_name] = this.getItemValidators(item.validation);
      return result;
    }, {});
  }

  // date utils
  public setDateDisabledRange(date: string, dateItemName: string, index?: number): void {
    dateUtils.setDateDisabledRange(date, dateItemName, this.segmentData, index);
  }

  public setDateAheadControlError(startDateControl: AbstractControl, endDateControl: AbstractControl): void {
    dateUtils.setDateAheadControlError(startDateControl, endDateControl);
  }

  public handleDateAheadChange(dateStart: AbstractControl, dateItemName: string, selectedDate: string, index?: number) {
    dateUtils.handleDateAheadChange(dateStart, dateItemName, selectedDate, this.segmentData, index);
  }
}
